import React from 'react'

/**
 * Static notes for email footer
 * Notes are numbered 1-4 and shown conditionally based on scenario
 */
const NOTES = {
    1: {
        fr:
            "Veuillez refaire une demande à la capitainerie si l'analyse a été effectuée plus de 24h avant le départ prévu.",
        en:
            "Please submit a new request to the Harbour Master's Office if the analysis was carried out more than 24 hours before the scheduled departure.",
    },
    2: {
        fr:
            'Vous pouvez mobiliser les intervenants (pilote, remorqueur(s), amarreurs) à tout moment dans la fenêtre prévue. Le délai réglementaire de 1h de mobilisation avant le dernier moment de départ a déjà été pris en compte.',
        en:
            'You may schedule stakeholders (pilot, tug(s), linesmen) at any time within the designated window. The 1h regulatory mobilization time before the latest departure moment has already been factored in.',
    },
    3: {
        fr: "Contacter l'APL pour les services de pilote lamaneur",
        en: 'Please contact LPA for harbour pilot services',
    },
    4: {
        fr:
            "Pour les quais 104, 105 et 106, l'option avec pilote Lamaneur est seulement possible si aucun navire n'est présent aux quai 107 et 108.",
        en:
            'For berths 104, 105, and 106, the option with a harbour pilot is only possible if no vessels are present at berths 107 and 108.',
    },
}

/**
 * Notes section component
 * Displays numbered footnotes based on which notes are needed
 *
 * @param {Array<number>} noteNumbers - Array of note numbers to display (1-4)
 */
export const Notes = ({ noteNumbers = [1, 2] }) => {
    // Filter to only valid note numbers
    const validNotes = noteNumbers.filter(n => NOTES[n])

    if (validNotes.length === 0) {
        return null
    }

    return (
        <>
            <h2>Notes / Notes :</h2>
            <table cellPadding='0' cellSpacing='0' style={{ borderCollapse: 'collapse' }}>
                <tbody>
                    {validNotes.map(noteNum => (
                        <React.Fragment key={noteNum}>
                            <tr>
                                <td style={{ verticalAlign: 'top', paddingRight: '4px' }}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <sup>{noteNum}</sup>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </td>
                                <td style={{ verticalAlign: 'top', paddingRight: '4px' }}>–</td>
                                <td style={{ verticalAlign: 'top' }}>
                                    <i>{NOTES[noteNum].fr}</i>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style={{ verticalAlign: 'top', paddingRight: '4px' }}>–</td>
                                <td style={{ verticalAlign: 'top', paddingBottom: '12px' }}>
                                    <i>{NOTES[noteNum].en}</i>
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </>
    )
}

/**
 * Helper to determine which notes to show based on scenario
 *
 * @param {string} calculationMethod - 'latest_time' or 'departure_range'
 * @param {boolean} hasPilotSections - Whether scenario has pilot sections
 * @param {string} dockLabel - Dock label (to check for 104, 105, 106)
 * @returns {Array<number>} Array of note numbers to display
 */
export const getNotesForScenario = (calculationMethod, hasPilotSections, dockLabel = '') => {
    // Notes 1 and 2 are always shown
    const notes = [1, 2]

    // Notes 3 and 4 are only shown for scenarios with pilot sections
    if (hasPilotSections) {
        notes.push(3)

        // Note 4 is only for docks 104, 105, 106
        const dockNum = parseInt(dockLabel, 10)
        if (dockNum === 104 || dockNum === 105 || dockNum === 106) {
            notes.push(4)
        }
    }

    return notes
}
